/* CENIT · Buscador que entiende cómo busca la gente.
   · Carga un índice ligero de piezas (templates/collection.cenit-index.liquid) la primera vez que se abre.
   · Entiende tipo de pieza ("pulseras"), color ("azul", "dorado"), constelación ("orion"), sinónimos
     configurables ("gatito" → Casiopea y Escorpio), acentos y errores de dedo ("escorpion", "andromda").
   · Sin texto: muestra búsquedas sugeridas, tipos de pieza y colores.
   · Atajos al catálogo filtrado: "anillo azul" → /collections/all?tipo=anillo&color=azul
   Lo usa sections/cenit-header.liquid (window.cenitSmartSearch). Si el índice no carga, el header
   vuelve a la búsqueda predictiva de Shopify. */
(function () {
  if (window.cenitSmartSearch) return;

  var KIND_WORDS = {
    anillo: 'anillo', anillos: 'anillo', ring: 'anillo', rings: 'anillo', sortija: 'anillo',
    collar: 'collar', collares: 'collar', necklace: 'collar', dije: 'collar', dijes: 'collar', colgante: 'collar', cadena: 'collar',
    pulsera: 'pulsera', pulseras: 'pulsera', bracelet: 'pulsera', brazalete: 'pulsera', esclava: 'pulsera'
  };
  var KIND_LABEL = { anillo: 'Anillos', collar: 'Collares', pulsera: 'Pulseras' };
  var KIND_ORDER = ['collar', 'pulsera', 'anillo'];
  var COLOR_WORDS = {
    azul: 'azul', azules: 'azul', blue: 'azul', zafiro: 'azul',
    celeste: 'celeste', celestes: 'celeste', turquesa: 'celeste', aqua: 'celeste', aguamarina: 'celeste', opalo: 'celeste',
    verde: 'verde', verdes: 'verde', green: 'verde', esmeralda: 'verde',
    morado: 'morado', morados: 'morado', morada: 'morado', moradas: 'morado', lila: 'morado', violeta: 'morado', purple: 'morado', amatista: 'morado',
    rosa: 'rosa', rosas: 'rosa', rosado: 'rosa', rosada: 'rosa', rosadas: 'rosa', pink: 'rosa',
    rojo: 'rojo', rojos: 'rojo', roja: 'rojo', rojas: 'rojo', red: 'rojo', rubi: 'rojo',
    amarillo: 'amarillo', amarillos: 'amarillo', amarilla: 'amarillo', amarillas: 'amarillo', yellow: 'amarillo', citrino: 'amarillo',
    dorado: 'dorado', dorados: 'dorado', dorada: 'dorado', doradas: 'dorado', oro: 'dorado', gold: 'dorado',
    multicolor: 'multicolor', arcoiris: 'multicolor', colores: 'multicolor', rainbow: 'multicolor'
  };
  var COLOR_LABEL = { azul: 'Azul', celeste: 'Celeste', verde: 'Verde', morado: 'Morado', rosa: 'Rosa', rojo: 'Rojo', amarillo: 'Amarillo', multicolor: 'Multicolor', dorado: 'Dorado' };
  var COLOR_ADJ = { azul: 'azules', celeste: 'celestes', verde: 'verdes', morado: 'morados', rosa: 'rosas', rojo: 'rojos', amarillo: 'amarillos', multicolor: 'multicolor', dorado: 'dorados' };
  var STOP = { de: 1, del: 1, la: 1, el: 1, los: 1, las: 1, con: 1, en: 1, y: 1, para: 1, un: 1, una: 1, mi: 1, color: 1, plata: 1 };

  var cfg = { catalog: '/collections/all', synonyms: {}, suggest: [] };
  var index = null;
  var loading = null;

  function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9ñ\s-]/g, ' ').trim(); }
  function esc(s) { return String(s || '').replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(c) { return '$' + Math.round((Number(c) || 0) / 100).toLocaleString('es-MX') + ' MXN'; }
  function img(url, w) {
    if (!url) return '';
    try { var u = new URL(url, location.origin); u.searchParams.set('width', w); return u.toString(); } catch (e) { return url; }
  }
  function lev(a, b) {
    if (Math.abs(a.length - b.length) > 2) return 9;
    var d = [], i, j;
    for (i = 0; i <= a.length; i++) d[i] = [i];
    for (j = 0; j <= b.length; j++) d[0][j] = j;
    for (i = 1; i <= a.length; i++) for (j = 1; j <= b.length; j++) {
      d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
    }
    return d[a.length][b.length];
  }

  function configure(el) {
    if (!el) return;
    cfg.catalog = el.getAttribute('data-catalog') || cfg.catalog;
    cfg.suggest = (el.getAttribute('data-suggest') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    (el.getAttribute('data-synonyms') || '').split(/\n/).forEach(function (line) {
      var parts = line.split(':');
      if (parts.length < 2) return;
      var targets = norm(parts.slice(1).join(':')).split(/[\s,]+/).filter(Boolean);
      parts[0].split(',').forEach(function (w) { w = norm(w); if (w) cfg.synonyms[w] = targets; });
    });
  }

  function load() {
    if (index) return Promise.resolve(index);
    if (loading) return loading;
    try {
      var cached = sessionStorage.getItem('cenit-search-index');
      if (cached) { index = prep(JSON.parse(cached)); return Promise.resolve(index); }
    } catch (e) {}
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    loading = fetch(root + 'collections/all?view=cenit-index', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('index'); return r.text(); })
      .then(function (txt) {
        var data = JSON.parse(txt);
        try { sessionStorage.setItem('cenit-search-index', JSON.stringify(data)); } catch (e) {}
        index = prep(data);
        return index;
      })
      .catch(function (err) { loading = null; throw err; });
    return loading;
  }

  function prep(list) {
    return list.map(function (p) {
      p.nt = norm(p.t);
      p.nh = norm(p.h.replace(/-/g, ' '));
      p.colors = (p.c || '').split(/\s+/).filter(Boolean);
      p.colls = (p.gh || '').split(/\s+/).filter(Boolean);
      p.hay = [p.nt, p.nh, norm(p.g), norm(p.tg), p.k, p.colors.join(' ')].join(' ');
      p.words = p.hay.split(/\s+/).filter(Boolean);
      return p;
    });
  }

  /* Interpreta la búsqueda: tipo, color, sinónimos y palabras libres */
  function parse(q) {
    var out = { kinds: [], colors: [], handles: [], free: [], synonymHit: false };
    norm(q).split(/\s+/).filter(Boolean).forEach(function (w, i, all) {
      if (STOP[w]) return;
      var pair = i < all.length - 1 ? w + ' ' + all[i + 1] : '';
      var syn = cfg.synonyms[w] || (pair && cfg.synonyms[pair]);
      if (syn) {
        out.synonymHit = true;
        syn.forEach(function (t) {
          if (KIND_WORDS[t]) out.kinds.push(KIND_WORDS[t]);
          else if (COLOR_WORDS[t]) out.colors.push(COLOR_WORDS[t]);
          else out.handles.push(t);
        });
        return;
      }
      if (KIND_WORDS[w]) { out.kinds.push(KIND_WORDS[w]); return; }
      if (COLOR_WORDS[w]) { out.colors.push(COLOR_WORDS[w]); return; }
      out.free.push(w);
    });
    return out;
  }

  function wordMatch(p, w) {
    if (p.hay.indexOf(w) > -1) return w.length >= 3 && (p.nt.indexOf(w) === 0) ? 3 : 2;
    if (w.length >= 4) {
      for (var i = 0; i < p.words.length; i++) {
        var pw = p.words[i];
        if (lev(w, pw.slice(0, w.length + 1)) <= 1 || lev(w, pw) <= (w.length > 6 ? 2 : 1)) return 1;
      }
    }
    return 0;
  }

  function run(q) {
    var it = parse(q);
    var res = [];
    index.forEach(function (p) {
      var score = 0;
      if (it.kinds.length && it.kinds.indexOf(p.k) < 0 && !it.handles.length) return;
      if (it.colors.length && !it.colors.some(function (c) { return p.colors.indexOf(c) > -1; })) return;
      if (it.handles.length) {
        var byHandle = it.handles.some(function (h) { return p.h === h || p.nh === h || p.nt === h; });
        var byKind = it.handles.some(function (h) { return KIND_WORDS[h] === p.k; });
        if (!byHandle && !byKind && !it.free.length) return;
        if (byHandle) score += 8;
      }
      for (var i = 0; i < it.free.length; i++) {
        var m = wordMatch(p, it.free[i]);
        if (!m) return;
        score += m;
      }
      if (p.nt === norm(q)) score += 10;
      if (p.a) score += 0.5;
      res.push({ p: p, s: score });
    });
    res.sort(function (a, b) { return b.s - a.s; });
    /* ¿La búsqueda es el nombre de una colección? (ej. "orion", "osa mayor") */
    var nq = norm(q), coll = null;
    index.some(function (p) {
      return p.colls.some(function (h, i) {
        var title = (p.gt || [])[i];
        if (h === nq.replace(/\s+/g, '-') || (title && norm(title) === nq)) { coll = { h: h, t: title || h }; return true; }
        return false;
      });
    });
    return { intent: it, products: res.map(function (r) { return r.p; }), coll: coll };
  }

  function catalogUrl(kinds, colors) {
    var u = cfg.catalog, qs = [];
    if (kinds.length) qs.push('tipo=' + kinds.filter(uniq).join(','));
    if (colors.length) qs.push('color=' + colors.filter(uniq).join(','));
    return u + (qs.length ? '?' + qs.join('&') : '');
  }
  function uniq(v, i, a) { return a.indexOf(v) === i; }

  function productCard(p) {
    return '<a class="cenit-search-product" href="' + esc(p.u) + '">' +
      '<div class="cenit-search-product__media">' + (p.i ? '<img src="' + esc(img(p.i, 480)) + '" alt="" loading="lazy" decoding="async">' : '') + '</div>' +
      '<div class="cenit-search-product__body"><span class="cenit-search-product__name">' + esc(p.t) + '</span>' +
      '<span class="cenit-search-product__price">' + money(p.p) + '</span></div></a>';
  }

  function chips(list) {
    return '<div class="cs-chips">' + list.map(function (s) {
      return '<button type="button" class="cs-chip" data-cs-q="' + esc(s) + '">' + esc(s) + '</button>';
    }).join('') + '</div>';
  }

  function colorsPresent() {
    var seen = {};
    index.forEach(function (p) { p.colors.forEach(function (c) { seen[c] = (seen[c] || 0) + 1; }); });
    return Object.keys(COLOR_LABEL).filter(function (c) { return seen[c]; });
  }

  function idleHtml() {
    var html = '';
    if (cfg.suggest.length) html += '<div class="cs-block"><p class="cs-label">Búsquedas sugeridas</p>' + chips(cfg.suggest) + '</div>';
    var tiles = KIND_ORDER.map(function (k) {
      var ps = index.filter(function (p) { return p.k === k; });
      if (!ps.length) return '';
      var cover = ps.filter(function (p) { return p.i; })[0];
      return '<a class="cs-tile" href="' + esc(catalogUrl([k], [])) + '">' +
        '<span class="cs-tile__img">' + (cover ? '<img src="' + esc(img(cover.i, 240)) + '" alt="" loading="lazy">' : '') + '</span>' +
        '<span class="cs-tile__name">' + KIND_LABEL[k] + '</span><span class="cs-tile__n">' + ps.length + ' piezas</span></a>';
    }).join('');
    if (tiles) html += '<div class="cs-block"><p class="cs-label">Explora por tipo</p><div class="cs-tiles">' + tiles + '</div></div>';
    var cols = colorsPresent();
    if (cols.length) {
      html += '<div class="cs-block"><p class="cs-label">Por color de piedra</p><div class="cs-chips">' + cols.map(function (c) {
        return '<a class="cs-chip cs-chip--color" href="' + esc(catalogUrl([], [c])) + '"><span class="kf-sw kf-sw--' + c + '" aria-hidden="true"></span>' + COLOR_LABEL[c] + '</a>';
      }).join('') + '</div></div>';
    }
    return html;
  }

  function shortcutLabel(it) {
    var k = it.kinds.filter(uniq), c = it.colors.filter(uniq);
    if (k.length === 1 && c.length === 1) {
      var adj = COLOR_ADJ[c[0]];
      if (k[0] === 'pulsera') adj = adj.replace(/os$/, 'as');
      return 'Ver ' + KIND_LABEL[k[0]].toLowerCase() + ' ' + adj;
    }
    if (k.length === 1 && !c.length) return 'Ver ' + KIND_LABEL[k[0]].toLowerCase() + ' en el catálogo';
    if (k.length > 1 && !c.length) return 'Ver ' + k.map(function (x) { return KIND_LABEL[x].toLowerCase(); }).join(' y ');
    if (!k.length && c.length === 1) return 'Ver piezas en ' + COLOR_LABEL[c[0]].toLowerCase();
    return 'Ver el catálogo con este filtro';
  }

  function resultsHtml(q, r) {
    var it = r.intent, ps = r.products, html = '';
    var shortcut = (it.kinds.length || it.colors.length) && !it.free.length && !it.handles.length ? shortcutLabel(it) : '';
    if (shortcut) {
      html += '<a class="cs-shortcut" href="' + esc(catalogUrl(it.kinds, it.colors)) + '" data-cs-shortcut>' +
        '<i class="ph ph-sliders-horizontal" aria-hidden="true"></i><span>' + esc(shortcut) + '</span><i class="ph ph-arrow-right" aria-hidden="true"></i></a>';
    }
    if (!shortcut && r.coll) {
      html += '<a class="cs-shortcut" href="' + esc(cfg.catalog + '?col=' + r.coll.h) + '" data-cs-shortcut>' +
        '<i class="ph ph-sparkle" aria-hidden="true"></i><span>Ver la colección ' + esc(r.coll.t) + '</span><i class="ph ph-arrow-right" aria-hidden="true"></i></a>';
    }
    if (!ps.length) {
      var nq = norm(q);
      var close = index.map(function (p) { return { p: p, d: lev(nq, p.nt) }; }).filter(function (x) { return x.d <= 3; })
        .sort(function (a, b) { return a.d - b.d; }).slice(0, 3).map(function (x) { return x.p.t; });
      html += '<div class="cs-empty"><p class="cs-empty__title">No encontramos “' + esc(q) + '”.</p>';
      if (close.length) html += '<p class="cs-label">¿Quisiste decir?</p>' + chips(close);
      else if (cfg.suggest.length) html += '<p class="cs-label">Prueba con</p>' + chips(cfg.suggest);
      html += '<a class="cs-link" href="' + esc(cfg.catalog) + '">Ver todo el catálogo</a></div>';
      return html;
    }
    html += '<div class="cenit-search-results-head"><h3>' + (it.synonymHit ? 'Te pueden gustar' : 'Resultados') + '</h3><span>' +
      ps.length + (ps.length === 1 ? ' pieza' : ' piezas') + '</span></div>' +
      '<div class="cenit-search-grid">' + ps.slice(0, 6).map(productCard).join('') + '</div>';
    if (ps.length > 6) {
      var more = shortcut ? catalogUrl(it.kinds, it.colors) : '/search?q=' + encodeURIComponent(q) + '&type=product';
      html += '<a class="cenit-search-all" href="' + esc(more) + '">Ver las ' + ps.length + ' piezas <span aria-hidden="true">→</span></a>';
    }
    return html;
  }

  window.cenitSmartSearch = {
    configure: configure,
    load: load,
    idle: function (body) {
      return load().then(function () { body.innerHTML = idleHtml(); });
    },
    query: function (q, body) {
      return load().then(function () { var r = run(q); body.innerHTML = resultsHtml(q, r); return r; });
    },
    /* Enter: producto exacto → su página; tipo/color → catálogo filtrado; si no, página de búsqueda */
    submitUrl: function (q) {
      if (!index) return null;
      var r = run(q), it = r.intent;
      if ((it.kinds.length || it.colors.length) && !it.free.length && !it.handles.length) return catalogUrl(it.kinds, it.colors);
      if (r.coll) return cfg.catalog + '?col=' + r.coll.h;
      if (r.products.length === 1 || (r.products[0] && r.products[0].nt === norm(q))) return r.products[0].u;
      return null;
    }
  };
})();
